const modals = {
  maxHeight: { mobile: '95vh', tablet: '95vh', default: '95vh' },
  maxWidth: { mobile: '95vw', tablet: '95vw', default: '680px' },
  borderRadius: { default: 4 },
}

export default modals
